import React from "react";
import { Navigate } from "react-router-dom";
import { useMe, useSurvey } from "@/api/hooks";
import SurveyForm from "@/components/survey/SurveyForm";
import GiveawayFooter from "@/components/giveaway/GiveawayFooter";
import GiveawayHeader from "@/components/giveaway/GiveawayHeader";

export default function Survey() {
  const { data: me, isLoading: meLoading } = useMe();
  const { data: survey, isLoading: surveyLoading } = useSurvey();

  if (meLoading || surveyLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#0a0a0a" }}>
        <div className="w-10 h-10 border-4 border-transparent rounded-full animate-spin" style={{ borderTopColor: "#c8f135" }} />
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ background: "#0a0a0a" }} dir="rtl">
      <GiveawayHeader />

      <SurveyForm fullName={me?.full_name} existing={survey?.completed ? survey : null} />
      <GiveawayFooter />
    </div>
  );
}
